import React from 'react';
export default function ReportsPage() {
  return (
    <div style={{ padding: '28px 32px', fontFamily: 'Inter, system-ui, sans-serif' }}>
      <h1 style={{ margin: '0 0 4px', fontSize: 24, fontWeight: 800, color: '#0F172A' }}>Reports</h1>
      <p style={{ margin: '0 0 24px', fontSize: 13, color: '#94A3B8' }}>Coming soon</p>
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #E2E8F0',
        padding: 48, textAlign: 'center', color: '#94A3B8' }}>
        <div style={{ fontSize: 40, marginBottom: 16 }}>📊</div>
        <div style={{ fontSize: 16, fontWeight: 600, color: '#0F172A', marginBottom: 8 }}>Reports coming soon</div>
        <div style={{ fontSize: 13 }}>Adherence rates, cycle stats, and delivery reports will appear here.</div>
      </div>
    </div>
  );
}
